export const RESET_STATUS = 'RESET_STATUS';

export const COMFIRM = 'COMFIRM';



// WEBPACK FOOTER //
// ./src/state/status/types.js